"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var temp = function MobileTwoTone(primaryColor, secondaryColor) {
  return {
    name: 'mobile',
    theme: 'twotone',
    nameWithTheme: 'mobile-twotone',
    tag: 'svg',
    attrs: {
      xmlns: 'http://www.w3.org/2000/svg',
      class: 'icon',
      viewBox: '0 0 1024 1024'
    },
    children: [{
      tag: 'path',
      attrs: {
        fill: primaryColor,
        d: 'M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: secondaryColor,
        d: 'M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
      },
      children: []
    }, {
      tag: 'path',
      attrs: {
        fill: primaryColor,
        d: 'M472 786a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
      },
      children: []
    }]
  };
};
temp.nameWithTheme = 'mobile-twotone';
var MobileTwoTone = temp;
exports.default = MobileTwoTone;